import { ArchiveAnnotationsListVM } from 'civil-status/view-models/archive-annotations-list';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<ArchiveAnnotationsListVM, keyof ArchiveAnnotationsListVM>[] = [
  {
    id: 'id',
    label: 'ID Comunicazione',
  },
  {
    id: 'practice',
    label: 'Pratica',
  },
  {
    id: 'description',
    label: 'Intestatari',
    colSpan: 2,
  },
  {
    id: 'dateFormation',
    label: 'Data formazione',
  },
  {
    id: 'act',
    label: 'Atto su cui annotare',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'dateRegistration',
    label: 'Data registrazione',
  },
  {
    id: 'action',
    label: 'Seleziona',
  },
];
